import React from 'react';
import { Box, Typography } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { FORM_STYLES } from '../../styles/formStyles';

interface FormSectionProps {
  icon: SvgIconComponent | React.ComponentType<any>;
  iconColor: string;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export const FormSection: React.FC<FormSectionProps> = ({
  icon: IconComponent,
  iconColor,
  title,
  subtitle,
  children
}) => {
  const { t } = useTranslation();

  // Render icon with props that work for both MUI and Lucide icons
  const renderIcon = () => {
    return (
      <IconComponent 
        style={{ fontSize: '20px', color: 'white' }}
      />
    );
  };

  return (
    <Box sx={FORM_STYLES.section.card}>
      {/* Header with Icon and Title */}
      <Box sx={FORM_STYLES.section.header}>
        <Box sx={{
          ...FORM_STYLES.section.icon,
          backgroundColor: iconColor
        }}>
          {renderIcon()}
        </Box>
        <Typography sx={FORM_STYLES.section.title}>
          {t(title)}
        </Typography>
      </Box>

      {/* Optional Subtitle */}
      {subtitle && (
        <Typography sx={FORM_STYLES.section.subtitle}>
          {t(subtitle)}
        </Typography>
      )}

      {/* Content */}
      {children}
    </Box>
  );
}; 